// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SubmitFeatureRequest_inputContainer__1INem"};